import React, { useState } from "react";
import { Modal } from "antd";
import "antd/dist/antd.css";
import { ShareModalContent } from "./ShareModalContent/ShareModalContent";
import ShareBtn from '../../assets/share-file.svg';
import './ShareModal.css';
import MyHeader from '../Header/Header.module.css';

export const ShareModal = ({ shareUrl }) => {
  const isMobile=window.screen.width<768
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [privacy, setPrivacy] = useState(0);

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleOk = () => {
    setIsModalVisible(false);
    setPrivacy(0);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    setPrivacy(0);
  };

  return (
    <>
      <div className={MyHeader.iconContainer} onClick={showModal} title="Share">
        <img src={ShareBtn} className={MyHeader.actionIconImg} alt="Share" />
      </div>
      <Modal
        title="Share with people and Groups"
        visible={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        // zIndex={9999}
        footer={false}
        // className="share-doc-modal"
      >
        <ShareModalContent shareUrl={shareUrl} setIsModalVisible={setIsModalVisible} privacy={privacy} setPrivacy={setPrivacy} />
      </Modal>
    </>
  );
};
